import React from 'react'
import './Clientsay.css'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import userimg from '../../assets/c-logo/2.svg'
import img1 from '../../assets/c-logo/3.png'
import img2 from '../../assets/c-logo/3-1.png'
import img3 from '../../assets/c-logo/4.png'
import img4 from '../../assets/c-logo/5.png'
import img5 from '../../assets/c-logo/6.png'
import img6 from '../../assets/c-logo/7.png'
import img7 from '../../assets/c-logo/8.png'
import img8 from '../../assets/c-logo/9.png'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const Clientsay = () => {
  return (
    <section className='clientsays clr-drk'>
        <div class="row pb-5">
                
                <div class="col-12">
                   
                     <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} infinite={true}
                            >
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img1} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">
                                        “We had a good experience working with Takshila’s placement team. The communication was clear, and the process was easy. The candidates we selected are showing strong technical skills and a positive attitude at work.”
                                    </p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Intel</h5>
                                        <h6 className='author-course'>TA Partner</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img2} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">“Takshila’s placement coordination was excellent. The engineers we hired from the Physical Design batch are performing well in our ongoing projects. They learn fast and show good team spirit.”</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Micron</h5>
                                        <h6 className='author-course'>HR</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img3} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">“The coordination from Takshila Institute during recruitment was excellent, with clear communication at every stage. The candidates we hired are performing well in tool-based tasks such as synthesis and STA, and they exhibit a great attitude toward continuous learning.”</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Tessolve Semiconductors</h5>
                                        <h6 className='author-course'>Talent Acquisition Specialist</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img4} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">“The placement process with Takshila Institute was highly organized and transparent. The students who joined us have shown strong fundamentals and a great learning mindset. We suggest including more hands-on training on advanced tools to further enhance their readiness.”</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Maverick Semiconductor Pvt. Ltd</h5>
                                        <h6 className='author-course'>HR VP</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={userimg} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">
                                        We found the candidates from Takshila Institute to be well-trained, confident, and technically strong.
                                        Their interview performance and professional behavior were impressive.
                                        The Placement Team coordinated smoothly and responded promptly throughout the process.
                                        We are happy with the candidates and look forward to future collaborations.
                                        </p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Wipro Limited</h5>
                                        <h6 className='author-course'>HR Specialist</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img5} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">We appreciate the quality of training provided at Takshila Institute. The candidates showed good analytical thinking, strong tool knowledge, and great teamwork skills.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>HCL Tech</h5>
                                        <h6 className='author-course'>Associate Manager</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img6} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The candidates from Takshila showed good skills in STA, clock tree synthesis, and floorplan optimization. They had a strong understanding of constraints and physical verification processes. They were also confident and showed good communication and behavior during interactions.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Cadence Design Systems</h5>
                                        <h6 className='author-course'>TA Manager</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img7} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The candidates from Takshila showed a good understanding of both front-end and back-end design concepts. They learned quickly, accepted feedback well, and performed well in both technical and HR rounds. Their positive attitude and enthusiasm for work were impressive.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Synopsys</h5>
                                        <h6 className='author-course'>Talent Acquisition Specialist</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img8} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">“The recruitment process with Takshila was seamless, and communication from the placement cell was very effective. The Analog Layout Design candidates have adapted well to our project flow and are consistently delivering high-quality results within timelines.”</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Insemi Technology Services</h5>
                                        <h6 className='author-course'>Senior Lead TA</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            
                            
                            </Carousel>

                </div>
            </div>
    </section>
  )
}

export default Clientsay